(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('activityFieldDescription', activityFieldDescription);

    function activityFieldDescription() {
        return {
            restrict: 'E',
            templateUrl: 'common/app/components/activities/activity-input/fields/description',
            controller: activityFieldDescriptionCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                inputData: '=?',
                model: '=',
                getInstance: '=?',
                preview: '=?',
                previewModel: '=?',
                onDiscard: '=?',
            }
        };
    }

    function activityFieldDescriptionCtrl(GenericModel, ActivitiesInputService, lodash, $element, $timeout, $rootScope, $scope) {
        var vm = this;
        this.$onInit = function() {
            vm.tinyMceInst = null;

            vm.getInstance = getInstance;
            vm.preview = { execute: preview, setSelectedPreview: setSelectedPreview, previewsList: [] };
            vm.onDiscard = onDiscard;

            init();

            $scope.$on('$destroy', function() {
                var editor = vm.getInstance();
                editor.removed = true;
            });
        }

        function init() {
            const additional = generateAdditional();
            const cdnEp = angular.element('div[data-cdn-ep]').attr('data-cdn-ep');
            additional.setup = function(editor) {
                vm.tinyMceInst = editor;

                editor.addButton('SODAttachment', {
                    text: '',
                    icon: 'paperclip',
                    onclick: function () {
                        $rootScope.$broadcast('onAddAttachmentClick');
                    }
                });

                editor.on('init', function () {
                    $timeout(function () {
                        var em = $element.find('.mce-toolbar-grp');
                        $element.remove('.mce-toolbar-grp');
                        $element.find('.mce-edit-area').after(em);
                    });
                });

                editor.on('blur', (function (editor) {
                    return function (e) {
                        e.preventDefault();
                        vm.model = editor.getContent();
                    };
                })(editor));

                editor.on('ExecCommand', function(e) {
                    const command = e.value;
                    const execCommandOption = lodash.get(vm, 'inputData.options.messageInput.nested.execCommandOption', []);
                    const foundCommand = lodash.find(execCommandOption, { command: command });

                    if (foundCommand) {
                        const node = editor.selection.getNode();

                        const criteria = lodash.get(foundCommand, 'criteria', []);
                        const transformedCriteria = lodash.map(criteria, function (singleCriteria) {
                            const property = lodash.get(singleCriteria, 'property', undefined);

                            const conditionType = lodash.get(singleCriteria, 'condition.type', '');
                            const conditionRegex = lodash.get(singleCriteria, 'condition.regex', '');

                            switch (conditionType) {
                                case 'string':
                                    return (new RegExp(conditionRegex)).test(node[property]);
                            }
                        });
                        const passedCriteria = lodash.every(transformedCriteria, Boolean);

                        if (passedCriteria) {
                            const run = lodash.get(foundCommand, 'run', []);

                            lodash.forEach(run, function (singleRun) {
                                const type = lodash.get(singleRun, 'type', '');

                                switch(type) {
                                    case 'style':
                                        const value = lodash.get(singleRun, 'value', '');
                                        const className = lodash.get(singleRun, 'className', '');
                                        const camelCasedClassName = lodash.camelCase(className);

                                        const hasValueBeenSet = node.style[camelCasedClassName] === value;
                                        tinymce.DOM.setStyle(node, className, hasValueBeenSet ? '' : value);
                                        break;
                                }
                            });
                        }
                    }
                });
            };
            additional.content_css = cdnEp + '/assets/css/rms-tinymce.css';
            additional.body_class = 'activity-description-input';

            const remoteOptions = lodash.get(vm, 'inputData.options.messageInput', {});
            const defaultOptions = ActivitiesInputService.getDefaultMessageInputOptions();
            const tmceOptions = angular.merge({}, defaultOptions, remoteOptions, additional);
            // vm.tmceOptions = angular.merge({}, defaultOptions, remoteOptions, additional);
            if (lodash.has(tmceOptions, 'toolbar1')) {
                delete tmceOptions.toolbar;
            }
            vm.tmceOptions = tmceOptions;

            vm.preview.config = {
                create: false,
                valueField: 'unique_value',
                labelField: 'email',
                delimiter: '',
                placeholder: 'Select Recipient',
                maxItems: 1,
                onChange: function (value) {
                    $timeout(function () {
                        setSelectedPreview();
                    });
                },
                copyClassesToDropdown: true,
            };
        }

        function generateAdditional() {
            const result = {};

            if (lodash.has(vm, 'inputData.options.messageInput.maxHeightResize')) {
                const parentClass = lodash.get(vm.inputData.options.messageInput, 'maxHeightResize.parentsClass', false);
                const parentElem = $element.parents(parentClass);
                if (parentElem.length > 0) {
                    const parentHeight = parentElem.height();
                    const offsetHeight = lodash.get(vm.inputData.options.messageInput, 'maxHeightResize.offsetHeight' , 0);
                    result.autoresize_max_height = parentHeight - offsetHeight;
                }

            }

            if (lodash.has(vm, 'inputData.options.messageInput.nested')) {
                const defaultOptions = ActivitiesInputService.getDefaultMessageInputOptions();
                const messageInputNested = lodash.get(vm, 'inputData.options.messageInput.nested');

                if (lodash.has(messageInputNested, 'plugins')) {
                    const defaultPlugins = defaultOptions.plugins.split(' ');
                    const additionalPlugins = lodash.get(messageInputNested, 'plugins');

                    const mergesPlugins = lodash.concat(defaultPlugins, additionalPlugins);
                    result.plugins = mergesPlugins.join(' ');
                }

                if (lodash.has(messageInputNested, 'toolbar')) {
                    const defaultToolbarSections = defaultOptions.toolbar.split(' | ');
                    const defaultToolbar = lodash.map(defaultToolbarSections, function (defaultToolbarSection) {
                        return defaultToolbarSection.split(' ');
                    });
                    const additionalToolbar = lodash.get(messageInputNested, 'toolbar');

                    const mergesToolbar = lodash.concat(defaultToolbar, additionalToolbar);
                    const joinedMergesToolbarSections = lodash.map(mergesToolbar, function (singleMergesToolbar) {
                        return singleMergesToolbar.join(' ');
                    });
                    const joinedMergesToolbar = joinedMergesToolbarSections.join(' | ');
                    result.toolbar = joinedMergesToolbar;

                    // loading of available templates without the content
                    const hasSODTemplateType = joinedMergesToolbar.indexOf('SODTemplateType') >= 0;
                    const hasSodTemplate = lodash.has(vm, 'inputData.options.sodTemplates.datasource.getEmailTemplatesWithType.url');
                    if (hasSODTemplateType && hasSodTemplate) {
                        callRemoteApi(lodash.get(vm, 'inputData.options.sodTemplates.datasource.getEmailTemplatesWithType'))
                            .then(function (res) {
                                populateSODTemplateType(res);
                            });
                    }
                }
            }

            return result;
        }

        function getInstance() {
            return vm.tinyMceInst;
        }

        function getToolbarGroupIndex(toolbars, needle) {
            const truthyTableToolbarGroup = lodash.map(toolbars, function (toolbar) {
                if (toolbar.indexOf(needle) >= 0) {
                    return true;
                }

                return false;
            });

            return truthyTableToolbarGroup.indexOf(true);
        }

        function populateSODTemplateType(templateWithTypes) {
            const editor = vm.getInstance();
            const editorToolbars = editor.getParam('toolbar').split(' | ');

            editor.SODTemplateEngine = { templateWithTypes: templateWithTypes };

            const toolbarSODTemplateTypeIndex = getToolbarGroupIndex(editorToolbars, 'SODTemplateType');
            if (toolbarSODTemplateTypeIndex >= 0) {
                editor.addButton('SODTemplateType', getSODTemplateTypeButtonConfig());
                rerenderTinyMCEButton('SODTemplateType');
            }

            const toolbarSODTemplateIndex = getToolbarGroupIndex(editorToolbars, 'SODTemplate');
            if (toolbarSODTemplateIndex >= 0) {
                editor.addButton('SODTemplate', getSODTemplateButtonConfig());
                rerenderTinyMCEButton('SODTemplateType');
            }
        }

        function getSODTemplateButtonConfig() {
            const editor = vm.getInstance();

            const selectedTemplate = lodash.get(editor, 'SODTemplateEngine.state.selectedTemplate', undefined);
            const selectedTemplateType = lodash.get(editor, 'SODTemplateEngine.state.selectedTemplateType', undefined);

            const templateWithTypes = editor.SODTemplateEngine.templateWithTypes;
            const templateWithType = lodash.find(templateWithTypes, { value: selectedTemplateType });

            const templates = lodash.get(templateWithType, 'templates', undefined);
            const foundSelectedTemplate = lodash.find(templates, { value: selectedTemplate });

            let updatedTemplates = lodash.filter(templates, function (template) {
                if (selectedTemplate && selectedTemplate === template.value) {
                    return false;
                }

                return true;
            });

            if (updatedTemplates && templates && updatedTemplates.length < templates.length) {
                updatedTemplates = updatedTemplates.concat([{
                    label: 'Clear Template',
                    value: null,
                }]);
            }

            const templatesMenu = lodash.map(updatedTemplates, function (template) {
                return {
                    text: template.label,
                    onclick: (function () {
                        return function () {
                            if (template.value === null) {
                                setSODTMCESubject('');
                                setEditorContentWithCommit('');
                                setSelectedTemplate(null);
                            } else {
                                callRemoteApi(lodash.get(vm, 'inputData.options.sodTemplates.datasource.getEmailTemplate'),{template_id:template.value})
                                    .then(function (data) {
                                        setSODTMCESubject(data.subject);
                                        setEditorContentWithCommit(data.content);
                                        setSelectedTemplate(template.value);
                                    });
                            }
                        };
                    })(template),
                };
            });
            const hasTemplatesMenu = templatesMenu.length > 0;

            return {
                type: 'menubutton',
                text: foundSelectedTemplate ? foundSelectedTemplate.label : lodash.get(vm.inputData, 'options.labels.template', 'Templates'),
                icon: false,
                menu: hasTemplatesMenu ? templatesMenu : [{
                    text: lodash.get(vm.inputData, 'options.labels.template_not_found', 'Templates Not Found'),
                    onclick: function () {},
                }],
            };
        }

        function getSODTemplateTypeButtonConfig() {
            const editor = vm.getInstance();

            const selectedTemplateType = lodash.get(editor, 'SODTemplateEngine.state.selectedTemplateType', undefined);
            const foundSelectedTemplateType = lodash.find(editor.SODTemplateEngine.templateWithTypes, { value: selectedTemplateType });

            const templateWithTypes = editor.SODTemplateEngine.templateWithTypes;
            let updatedTemplateWithTypes = lodash.filter(templateWithTypes, function (templateWithType) {
                if (selectedTemplateType && selectedTemplateType === templateWithType.value) {
                    return false;
                }

                return true;
            });

            if (updatedTemplateWithTypes && templateWithTypes && updatedTemplateWithTypes.length < templateWithTypes.length) {
                updatedTemplateWithTypes = updatedTemplateWithTypes.concat([{
                    label: lodash.get(vm.inputData, 'options.labels.clear_template_type', 'Clear Template Type'),
                    value: null,
                }]);
            }

            const templateWithTypesMenu = lodash.map(updatedTemplateWithTypes, function (templateWithType) {
                return {
                    text: templateWithType.label,
                    onclick: (function () {
                        return function () {
                            updateSelectedTemplateType(templateWithType.value);

                            if (templateWithType.value === null) {
                                setSODTMCESubject('');
                                setEditorContentWithCommit('');
                                setSelectedTemplate(null);
                            }
                        };
                    })(templateWithType),
                };
            });

            const hasTemplateWithTypesMenu = templateWithTypesMenu.length > 0;

            return {
                type: 'menubutton',
                text: foundSelectedTemplateType ? foundSelectedTemplateType.label : lodash.get(vm.inputData, 'options.labels.template_type', 'Template Types'),
                icon: false,
                menu: hasTemplateWithTypesMenu ? templateWithTypesMenu : [{
                    text: 'Template Types Not Found',
                    onclick: function () {},
                }],
            };
        }

        function updateSelectedTemplateType(selectedTemplateType) {
            const editor = vm.getInstance();

            const SODTemplateEngineState = editor.SODTemplateEngine.state;
            editor.SODTemplateEngine.state = Object.assign({}, SODTemplateEngineState, {
                selectedTemplateType: selectedTemplateType,
            });

            editor.buttons['SODTemplateType'] = Object.assign({}, editor.buttons['SODTemplateType'], getSODTemplateTypeButtonConfig());
            rerenderTinyMCEButton('SODTemplateType');

            editor.buttons['SODTemplate'] = Object.assign({}, editor.buttons['SODTemplate'], getSODTemplateButtonConfig());
            rerenderTinyMCEButton('SODTemplate');
        }

        function setSelectedTemplate(selectedTemplate) {
            const editor = vm.getInstance();

            const SODTemplateEngineState = editor.SODTemplateEngine.state;
            editor.SODTemplateEngine.state = Object.assign({}, SODTemplateEngineState, {
                selectedTemplate: selectedTemplate,
            });

            editor.buttons['SODTemplate'] = Object.assign({}, editor.buttons['SODTemplate'], getSODTemplateButtonConfig());
            rerenderTinyMCEButton('SODTemplate');
        }

        function rerenderTinyMCEButton(button) {
            const editor = vm.getInstance();
            const editorToolbars = editor.getParam('toolbar').split(' | ');
            const buttonIndex = getToolbarGroupIndex(editorToolbars, button);

            if (buttonIndex >= 0) {
                const bg = editor.theme.panel.find('toolbar buttongroup')[buttonIndex];
                bg._lastRepaintRect = bg._layoutRect;
                if (bg._items.length > 0) {
                    bg.find('menubutton').each(function (t) {
                        t.remove()
                    });
                }

                const buttons = editorToolbars[buttonIndex].split(' ');
                lodash.forEach(buttons, function (oButton) {
                    bg.append(editor.buttons[oButton]);
                });
            }
        }

        function preview(datasource) {
            $timeout(function () {
                if (lodash.get(vm.preview, 'executing', false)) {
                    return;
                }

                const editor = vm.getInstance();
                let onPreview = lodash.get(vm, 'preview.on', false);
                onPreview = !onPreview;
                if (onPreview) {
                    setEditorReadMode(true);
                    lodash.set(vm.preview, 'executing', true);

                    const postData = angular.copy(lodash.get(vm, 'previewModel', {}));
                    resetPreviewData();
                    callRemoteApi(datasource, postData)
                        .then(function (data) {

                            // const firstData = lodash.head(data);
                            // const originalContent = editor.getContent({ format: 'raw' });
                            // lodash.set(vm, 'preview.originalContent', originalContent);
                            // lodash.set(vm, 'preview.originalSubject', lodash.get(vm, 'previewModel.txt_email_subject', ''));
                            //
                            // setEditorContentWithCommit(lodash.get(firstData, 'body', ''));
                            // setSODTMCEEditorSubjectContentWithCommit(lodash.get(firstData, 'subject', ''));
                            //
                            // lodash.set(vm.preview, 'data', firstData);

                            var previewsList = lodash.map(data, function (oData) {
                                return lodash.head(oData.to);
                            });
                            lodash.set(vm.preview, 'previewsList', previewsList);
                            lodash.set(vm.preview, 'previews', data);
                            setSelectedPreview(lodash.head(data));
                        })
                        .catch(function (error) {
                            resetPreviewData();
                            console.error('error', error);
                        }).finally(function() {
                        lodash.set(vm.preview, 'executing', false);
                        vm.preview.on = onPreview;
                    });
                } else {
                    setEditorReadMode(false);
                    const originalContent = lodash.get(vm, 'preview.originalContent', '');
                    const originalSubject = lodash.get(vm, 'preview.originalSubject', '');
                    setEditorContentWithCommit(originalContent);
                    setSODTMCEEditorSubjectContentWithCommit(originalSubject);

                    vm.preview.on = onPreview;
                }
            }, 300);
        }

        function setSelectedPreview(preview) {
            var selectedId = undefined;
            var hasPreview = lodash.isEmpty(preview);
            if (!hasPreview) {
                selectedId = lodash.get(preview, 'to[0].unique_value');
                lodash.set(vm.preview, 'selected', selectedId);
            } else {
                selectedId = parseInt(lodash.get(vm.preview, 'selected'));
            }

            var previewData = lodash.find(vm.preview.previews, { to: [{ unique_value: selectedId }]});
            previewData = Object.assign(previewData, {
                attachments: angular.copy(lodash.get(vm, 'previewModel.attachments', [])),
            });

            const editor = vm.getInstance();
            const originalContent = editor.getContent({ format: 'raw' });
            lodash.set(vm, 'preview.originalContent', originalContent);
            lodash.set(vm, 'preview.originalSubject', lodash.get(vm, 'previewModel.txt_email_subject', ''));

            // setEditorContentWithCommit(lodash.get(previewData, 'body', ''));
            // setSODTMCEEditorSubjectContentWithCommit(lodash.get(previewData, 'subject', ''));

            lodash.set(vm.preview, 'data', previewData);
        }

        function resetPreviewData() {
            lodash.set(vm.preview, 'data', {
                to: [], from: [], cc: [], bcc: [], body: null, attachments: [],
            });
        }

        function setEditorReadMode(mode) {
            if (mode) {
                $('.mce-tinymce.mce-container').css({
                    'pointer-events': 'none',
                    'opacity': '0.8',
                });
                return;
            }

            $('.mce-tinymce.mce-container').css({
                'pointer-events': 'auto',
                'opacity': '1',
            });
        }

        function setSODTMCEEditorSubjectContentWithCommit(data) {
            const editor = vm.getInstance();

            const SODTMCESubjectEditor = lodash.find(editor.editorManager.editors, { SODTMCESubject: true });
            if (SODTMCESubjectEditor) {
                SODTMCESubjectEditor.setContent(data);
                vm.previewModel.txt_email_subject = data;
                SODTMCESubjectEditor.save();
                SODTMCESubjectEditor.fire('Change');
            }
        }

        function setEditorContentWithCommit(data) {
            const editor = vm.getInstance();

            editor.setContent(data || '');
            vm.model = data;
            editor.save();
            editor.fire('Change');
        }

        function setSODTMCESubject(data) {
            const editor = vm.getInstance();

            const SODTMCESubjectEditor = lodash.find(editor.editorManager.editors, { SODTMCESubject: true });
            if (SODTMCESubjectEditor) {
                SODTMCESubjectEditor.setContent(data);
                vm.previewModel.txt_email_subject = data;
                SODTMCESubjectEditor.save();
                SODTMCESubjectEditor.fire('Change');
            }
        }

        function onDiscard() {
            updateSelectedTemplateType(null);
            setSelectedTemplate(null);
        }

        function callRemoteApi(datasource, postData) {
            var model = new GenericModel(datasource.url);
            var method = lodash.get(datasource, 'method', 'get');

            var queries = postData;
            var params = {};

            if (method !== 'get') {
                queries = {};
                params = {
                    data: postData,
                }
            }

            return model[method](queries, params).$promise.then(function(res) { //res
                if (res.success && res.status_code == 200) {
                    if (lodash.has(res, 'selected')) {
                        vm.modelContent = res.selected;
                        vm.ngModelCtrl.$setViewValue(res.selected);
                    }
                    return res.data;
                } else {
                    return null;
                }
            }, function(res) {
                console.warn(res); // eslint-disable-line no-console
                return null;
            });
        }
    }

})();